<template>
  <div class="flex flex-col  flex-1">
    <leaderboard :quiz="quiz" v-if="show === 'leaderboard'" @close="show = null" />
    <answers v-else-if="show === 'answers'" @close="show = null"/>

    <template v-else>
      <topbar :title="$t('quiz.page-title')" color="purple" />

      <div v-if="award.time"  class="flex flex-col flex-1 p-3 xl:pt-8">
        <div class="flex-1 max-w-xl xl:max-w-6xl w-full mx-auto">
          <div class="title text-quiz-1 xl:font-bold xl:text-5xl">
            {{$t('quiz.compliments')}} {{$store.getters.friendlyName}}!
          </div>
          <div class="xl:text-4xl">
            <p>{{phrase}}.</p>
            <p>
              Il quiz rimane aperto fino al {{deadline}}.
              Il vincitore sarà annunciato sui canali social di <i>lìdatè</i>. 
            </p>

          </div>
        </div>
        <div class="flex xl:flex-1 max-w-3xl w-full mx-auto items-center">
          <button class="btn btn-quiz-2 mr-1 w-1/2" @click="show = 'answers'">
            {{$t('quiz.solutions')}}
          </button>
          <button class="btn btn-quiz-1 ml-1 w-1/2" @click="show = 'leaderboard'">
            {{$t('quiz.leaderboard')}}
          </button>
        </div>
      </div>

      <div v-else>
        <div class="my-2 flex-1 p-3">
          In attesa dei risultati...
        </div>
      </div>

    </template>

  </div>
</template>

<script>
import Leaderboard from '@/components/quizzes/Leaderboard'
import Answers from '@/components/quizzes/Answers'
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      show: null,
    }
  },
  components: {
    Leaderboard,
    Answers,
  },
  props: {
    award: Object,
    quiz: String
  },
  mounted() {
    if(this.quiz) {
      this.bindQuiz(this.quiz)
      this.bindLeaderboard({id: this.quiz}),
      this.bindScoreboard({id: this.quiz})
    }
  },
  beforeDestroy() {
    this.unbindLeaderboard()
    this.unbindScoreboard({id: this.quiz})
  },
  methods: {
    ...mapActions('quiz', ['bindQuiz', 'bindLeaderboard', 'unbindLeaderboard', 'bindScoreboard', 'unbindScoreboard']),
  },
  computed: {
    phrase() {
      const mins = Math.floor(this.award.time / 60)
      const secs = Math.floor(this.award.time % 60)

      let time
      if(mins >= 1) {
        time = `${this.$tc('time.minutes', mins, [mins])} ${this.$t('time.and')} ${this.$tc('time.seconds', secs, [secs])}`
      } else {
        time = this.$tc('time.seconds', secs, [secs])
      }

      return this.$tc('quiz.award-phrase', this.award.correct, {correct: this.award.correct, time})
    },
    ...mapState('quiz', ['status']),
    deadline() {
      if(this.status && this.status.deadline) {
        const date = new Date(this.status.deadline._seconds * 1000 - 3600000 * 3)
        return `${date.getDate()}.${date.getMonth()+1}.${date.getFullYear()}`
      }
      return '';
    }
  }
}
</script>

<style>

</style>